export namespace DateFormatConstants {
    export const YearMonthDayFormat: string = 'YYYY-MM-DD';
}

export namespace ScheduleTypeConstants {
    export const Monday: string = 'Monday';
    export const Tuesday: string = 'Tuesday';
    export const Wednesday: string = 'Wednesday';
    export const Thursday: string = 'Thursday';
    export const Friday: string = 'Friday';
    export const Saturday: string = 'Saturday';
    export const Sunday: string = 'Sunday';

    export const Morning: string = 'AM';
    export const Afternoon: string = 'PM';

    export const ClubBefore: string = 'ClubBefore';
    export const ClubMid: string = 'ClubMid';
    export const ClubAfter: string = 'ClubAfter';
}

export namespace CustomPayRateReason {
  export const NationalMinimumWage = 2;
}